import { render, staticRenderFns } from "./InternshipForm.vue?vue&type=template&id=f2a8cb72&scoped=true&"
import script from "./InternshipForm.vue?vue&type=script&lang=js&"
export * from "./InternshipForm.vue?vue&type=script&lang=js&"
import style0 from "./InternshipForm.vue?vue&type=style&index=0&id=f2a8cb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a8cb72",
  null
  
)

export default component.exports